module.exports = __webpack_public_path__ + "img/gzhlwfy_logo_img.174f2240.png";